export default __webpack_public_path__ + "static/http_logo-7cdac8288bb6ce5b175cb6614d7c7ba9.svg";